<template>
<div>
    toggle is present!
    <transition name="growFade">
        <slot name="image" v-if="isVisible"></slot>
    </transition>
    <button @click="isVisible = !isVisible">
        <slot name="button"></slot>
    </button>
</div>
</template>

<script>
export default {
    data() {
        return {
            isVisible: false
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.growFade-enter-active,
.growFade-leave-active {
    transition: opacity 300ms, transform 300ms;
}

.growFade-enter,
.growFade-leave-to {
    opacity: 0;
    transform: scale(0)
}


</style>

